import { useRequest } from '@byted/hooks';
import { Toast } from '@douyinfe/semi-ui';
import { forumPostService } from '@/api/forumPost';
import {
  CreateReplyRequest,
  DeleteReplyRequest,
} from '@/typings/open.platform.forum_bff/namespaces/forumpost';

const fetch = async (req: CreateReplyRequest) => {
  const res = await forumPostService.createReply(req);
  if (res.error) {
    throw new Error(res.message);
  }
  return res.data;
};
const delFetch = async (req: DeleteReplyRequest) => {
  const res = await forumPostService.deleteReply(req);
  if (res.error) {
    throw new Error(res.message);
  }
  return res.data;
};

export const useReply = () => {
  const { run, loading } = useRequest(fetch, {
    auto: false,
    onError() {
      Toast.error('回复失败');
    },
    onSuccess() {
      Toast.success('回复成功');
    },
  });
  const { run: deleteReply } = useRequest(delFetch, {
    auto: false,
    onSuccess() {
      Toast.success('删除回复成功');
    },
    onError() {
      Toast.error('删除回复失败');
    },
  });
  return {
    run,
    loading,
    deleteReply,
  };
};
